// extracted by mini-css-extract-plugin
module.exports = {"ecMultipleBadge":"MultipleBadge_ecMultipleBadge__qrv3D","showScale":"MultipleBadge_showScale__lQgEQ"};